<template>
    <div>
        <rateios
            :contratacaoRateios="contratacaoRateios"
            v-show="mostrarContratacaoRateios"
            :dotacoesServicos="obterServicos()"
            @atualizarContratacaoRateios="contratacaoRateios = $event"
        >
            <!-- <template slot="acoes" slot-scope="data">
                <span class="text-primary" v-if="$temAcessoView('UABS-CONT-01')">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharContratacao(data.codContratacao)"
                    ></i>
                </span>
            </template> -->
        </rateios>
        <router-view></router-view>
    </div>
</template>

<script>
import RateiosServicos from './RateiosServicos'
import Rateios from '@/app/credenciados/componentes/rateios/Rateios'

export default {
    components: {
        Rateios
    },

    data() {
        return {
            contratacaoRateios: {}
        }
    },

    methods: {
        obterRateios() {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterTodos(this.$route.params.contratacaoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.contratacaoRateios = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterServicos() {
            return RateiosServicos
        }

        // detalharContratacao(id) {
        // 	this.$router.push({
        // 		name: `Uabs_Contratacoes_Detalhar`,
        // 		params: {
        // 			contratacaoId: id
        // 		}
        // 	})
        // }
    },

    created() {
        this.obterRateios()
    },

    computed: {
        mostrarContratacaoRateios() {
            return this.$route.name === 'Uabs_Contratacoes_Rateios'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Uabs_Contratacoes_Rateios') {
                if (this.$store.getters.recarregar) {
                    this.obterRateios()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
